<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="toc">
<p class="ctfm">Contents</p>
<p class="tocfm"><a href="#/eerbauckham0006#tab" id="rtab"><em>Tables</em></a></p>
<p class="tocfm"><a href="#/eerbauckham0007#pre" id="rpre"><em>Preface</em></a></p>
<p class="tocfm"><a href="#/eerbauckham0008#abb" id="rabb"><em>Abbreviations</em></a></p>
<p class="toc"><a href="#/eerbauckham0009#ch01" id="rch01">1. From the Historical Jesus to the Jesus of Testimony</a></p>
<p class="toc"><a href="#/eerbauckham0010#ch02" id="rch02">2. Papias on the Eyewitnesses</a></p>
<p class="toc"><a href="#/eerbauckham0011#ch03" id="rch03">3. Names in the Gospel Traditions</a></p>
<p class="toc"><a href="#/eerbauckham0012#ch04" id="rch04">4. Palestinian Jewish Names</a></p>
<p class="toc"><a href="#/eerbauckham0013#ch05" id="rch05">5. The Twelve</a></p>
<p class="toc"><a href="#/eerbauckham0014#ch06" id="rch06">6. Eyewitnesses “from the Beginning”</a></p>
<p class="toc"><a href="#/eerbauckham0015#ch07" id="rch07">7. The Petrine Perspective in the Gospel of Mark</a></p>
<p class="toc"><a href="#/eerbauckham0016#ch08" id="rch08">8. Anonymous Persons in Mark’s Passion Narrative</a></p>
<p class="toc"><a href="#/eerbauckham0017#ch09" id="rch09">9. Papias on Mark and Matthew</a></p>
<p class="toc"><a href="#/eerbauckham0018#ch10" id="rch10">10. Models of Oral Tradition</a></p>
<p class="toc"><a href="#/eerbauckham0019#ch11" id="rch11">11. Transmitting the Jesus Traditions</a></p>
<p class="toc"><a href="#/eerbauckham0020#ch12" id="rch12">12. Anonymous Tradition or Eyewitness Testimony?</a></p>
<p class="toc"><a href="#/eerbauckham0021#ch13" id="rch13">13. Eyewitness Memory</a></p>
<p class="toc"><a href="#/eerbauckham0022#ch14" id="rch14">14. The Gospel of John as Eyewitness Testimony</a></p>
<p class="toc"><a href="#/eerbauckham0023#ch15" id="rch15">15. The Witness of the Beloved Disciple</a></p>
<p class="toc"><a href="#/eerbauckham0024#ch16" id="rch16">16. Papias on John</a></p>
<p class="toc"><a href="#/eerbauckham0025#ch17" id="rch17">17. Polycrates and Irenaeus on John</a></p>
<p class="toc"><a href="#/eerbauckham0026#ch18" id="rch18">18. The Jesus of Testimony</a></p>
<p class="tocbm"><a href="#/eerbauckham0027#ind01" id="rind01"><em>Index of Ancient Persons</em></a></p>
<p class="tocbm"><a href="#/eerbauckham0028#ind02" id="rind02"><em>Index of Modern Authors</em></a></p>
<p class="tocbm"><a href="#/eerbauckham0029#ind03" id="rind03"><em>Index of Places</em></a></p>
<p class="tocbm"><a href="#/eerbauckham0030#ind04" id="rind04"><em>Index of Scriptures and Other Ancient Writings</em></a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0005.vue?1f98406a